import React, { useContext } from 'react'

const PresentModeContext = React.createContext(null)

const usePresentMode = () => {
  return useContext(PresentModeContext)
}

export { PresentModeContext, usePresentMode }
